import { Button, Icon, Tooltip } from "@outschool/backpack";
import { PublicReviewFragmentFragment } from "@outschool/gql-frontend-generated";
import { faCommentAltEdit } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import React from "react";

import { RESPONSE_TIME_LIMIT_IN_DAYS } from "../../../shared/Feedback";
import { ReviewResponseModal } from "./ReviewResponseModal";

type ReviewRespondButtonProps = {
  activity: PublicReviewFragmentFragment["activity"];
  review: PublicReviewFragmentFragment;
};

export const ReviewRespondButton: React.FunctionComponent<
  ReviewRespondButtonProps
> = ({ activity, review }) => {
  const { t } = useTranslation(
    "client\\components\\reviews\\ReviewRespondButton",
  );
  const [open, setOpen] = React.useState(false);

  const handleRespondClick = (e: $TSFixMe) => {
    e.preventDefault();
    if (review.currentUserCanRespond) {
      setOpen(true);
    }
  };

  const handleModalClose = () => setOpen(false);

  return (
    <>
      {open && (
        <ReviewResponseModal
          activity={activity}
          review={review}
          onClose={handleModalClose}
        />
      )}
      <Tooltip
        placement="bottom-start"
        title={
          !review.currentUserCanRespond && !review.teacher_responded_at
            ? t("You can’t respond to reviews older than {{numDays}} days.", {
                numDays: RESPONSE_TIME_LIMIT_IN_DAYS,
              })
            : null
        }
      >
        {/* 
        Have to wrap this in a span to allow the tooltip to work on disabled button 
        https://mui.com/material-ui/react-tooltip/#disabled-elements 
        */}
        <span>
          <Button
            variant="link"
            onClick={handleRespondClick}
            disabled={!review.currentUserCanRespond}
            sx={{
              color: "primary.700",
              mb: 24,
            }}
            startIcon={<Icon icon={faCommentAltEdit} />}
          >
            {t`Reply`}
          </Button>
        </span>
      </Tooltip>
    </>
  );
};
